module.exports = __webpack_public_path__ + "img/php.3d63916f.png";